
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {httpResource} from "@/resources/http.resource";
  import {bus} from "@/plugins/bus";
  import {IBook} from "@/interfaces/book.interface";
  import {IScreenPay} from "@/modules/ScreenPay/interfaces/screen-pay.interface";

  @Component({
    components: {
      AppDialog,
    },
  })
  export default class CashPayPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'cashPayPopup' };
    formModel = {
      tsum: null,
      carNumber: '',
      parkId: null,
      corpId: null,
    }
    hideParks = false;
    formRules = {
      carNumber: [{
        validator: (rule, value, callback) => {
          let valid = value.length >= 7 && value.length <= 9;
          return valid ? callback() : callback(new Error('Требуется 7-9 знаков'))
        },
        required: true,
        message: 'Требуется 7-9 знаков',
        trigger: 'blur'
      }],
      parkId: [{ required: true, message: ' ', trigger: 'blur' }],
      tsum: [{ validator: (rule, value, callback) => value > 0 ? callback() : callback(new Error(' ')), message: ' ', trigger: 'blur' }],
    };

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get parkValues() { return this.$store.state.book.books[IBook.BookName.parks]; }

    created() {
      this.formModel = {...this.payloadPopup.formModel, };
      this.hideParks = this.payloadPopup.hideParks;
    }

    async mounted() {
      await this.$nextTick();
      const inputNumber: any = this.$refs.inputNumber.$refs.input;
      inputNumber.focus();
    }

    async setCashValue() {
      this.$refs.cashForm.validate(async (valid) => {
        if (!valid) return false;

        let asyncAction = async () => {
          const params: any = { ...this.formModel, };
          await httpResource.httpAction({ action: 'PayCash', params });
        };
        let response = await this.$store.dispatch('defaultResourceAction', { asyncAction });
        if (response.success) {
          bus.$notify({title: 'Успешно', message: 'Наличные внесены, см. закладку Движение.', type: 'success', });
        }
        else {
          bus.$notify({title: 'Ошибка', message: 'Произошла непредвиденная ошибка, повторите операцию еще раз.', type: 'error', });
        }
        await this.onClose();
      });
    }

    async getSum() {
      let asyncAction = async () => {
        let action = IScreenPay.Action;
        let params: any = { carNumber: this.formModel.carNumber, };
        const { data: { result: response} } = await httpResource.httpAction({ action, params });
        if (response.CarSaldo) {
          this.formModel.tsum = response.CarSaldo.saldo;
        }
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }

  }
